<template>
	<div class="container-fluid" :class="`${templateData.letsbld_url}-container`">
		<intel-promo-hero
			v-if="
				templateData.letsbld_url == 'gamer-day' &&
					templateData.landing_page_builds
			"
			:builds="templateData.landing_page_builds"
			@customize-build="bldNumber => sendToConfigurator(bldNumber, true)"
		/>
		<amd-promo-hero
			v-if="
				templateData.letsbld_url == 'amd' && templateData.landing_page_builds
			"
			:builds="templateData.landing_page_builds"
			@customize-build="bldNumber => sendToConfigurator(bldNumber, true)"
		/>
		<!-- home -->
		<template v-for="section in templateData.landing_page_sections">
			<div
				v-if="section.position == 'top'"
				id="hero"
				:class="templateData.letsbld_url"
				:key="'section-' + section.id"
				:style="{ backgroundImage: 'url(' + section.background_url + ')' }"
				class="row section-global pos-r section-block"
			>
				<div v-if="!section.gleam_embed" class="static-pages">
					<div class="static-pages-title">
						<div class="container">
							<div class="content-holder">
								<div
									class="intro-image"
									:style="{ order: getContentOrder(section, 'intro') }"
								>
									<img :src="section.logo_url" class="img-response-w" >
								</div>
								<div
									class="text-wrapper-mid landing-page-heading"
									:style="{ order: getContentOrder(section, 'heading') }"
								>
									<img
										v-if="section.mini_logo_url"
										:src="section.mini_logo_url"
										class="p-b"
										:style="{ order: getContentOrder(section, 'mini_logo') }"
									>
									<h1
										class="text-white text-upper"
										v-html="section.title"
										:style="{ order: getContentOrder(section, 'title') }"
									/>
									<h3
										class="text-white m-t-lg ql-editor"
										v-html="section.body"
										:style="{ order: getContentOrder(section, 'body') }"
									/>
									<div v-html="section.klaviyo_embed" style="order: 2;" />
									<div class="btn-brothers" style="order: 2;">
										<template v-for="button in section.landing_page_buttons">
											<a
												v-if="button.type == 1"
												:key="'button-' + button.id"
												:href="button.url"
												target="_blank"
												:class="`btn-section-${section.id}-${button.id}`"
												class="btn btn-green"
											>
												{{ button.text }}
											</a>
											<a
												v-if="button.type == 2"
												:key="'button-' + button.id"
												:class="`btn-section-${section.id}-${button.id}`"
												class="btn btn-green m-y-md"
												@click="scrollToDiv('#influencer-pc')"
											>
												{{ button.text }}
											</a>
											<button
												v-if="button.type == 3"
												:key="'button-' + button.id"
												:class="`btn-section-${section.id}-${button.id}`"
												class="btn btn-green m-y-md"
												@click="openVideoModal(button.url)"
											>
												{{ button.text }}
											</button>
											<a
												v-if="button.type == 4"
												:key="'button-' + button.id"
												:class="`btn-section-${section.id}-${button.id}`"
												class="btn btn-green m-y-md"
												@click.prevent="sendToConfigurator(button.url, true)"
											>
												{{ button.text }}
											</a>
											<a
												v-if="button.type == 5"
												:key="'button-' + button.id"
												:class="`btn-section-${section.id}-${button.id}`"
												class="btn btn-green m-y-md"
												href="#"
												@click.prevent="scrollToDiv(button.url)"
											>
												{{ button.text }}
											</a>
										</template>
									</div>
									<!-- social -->
									<div
										v-if="section.has_social_links == 1"
										class="social-follow"
									>
										<h3 class="text-white">
											Follow {{ templateData.influencer_name }}:
										</h3>
										<div class="social-follow__link-container">
											<a
												v-if="templateData.twitch"
												:href="templateData.twitch"
												target="_blank"
											>
												<img
													src="/images/brand-logos/twitch.svg"
													alt="TwitchTV"
													width="79"
												>
											</a>
											<a
												v-if="templateData.mixer_url"
												:href="templateData.mixer_url"
												target="_blank"
											>
												<img
													src="/images/brand-logos/mixer.svg"
													alt="Mixer"
													width="70"
												>
											</a>
											<a
												v-if="templateData.youtube"
												:href="templateData.youtube"
												target="_blank"
											>
												<img
													src="/images/brand-logos/youtube.svg"
													alt="YouTube"
													width="79"
												>
											</a>
											<a
												v-if="templateData.twitter"
												:href="templateData.twitter"
												target="_blank"
											>
												<img
													src="/images/logos/twitter.svg"
													alt="Twitter"
													width="79"
												>
											</a>
										</div>
									</div>
									<!-- /.social -->
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- SECTION WITH GLEAM PROMO -->
				<section v-else class="static-pages gleam-section">
					<div class="static-pages-title container">
						<div class="row gleam-section__container">
							<div
								v-if="!!section.title.trim() || !!section.body.trim()"
								class="col-md-6"
							>
								<div class="gleam-section-text">
									<h2 class="gleam-section-heading text-uppercase">
										{{ section.title | stripTags }}
									</h2>
									<div class="ql-editor" v-html="section.body" />
								</div>
							</div>
							<div class="col-md-6">
								<div
									class="gleam-section-insert"
									v-html="section.gleam_embed"
								/>
							</div>
						</div>
					</div>
				</section>
				<!-- /.SECTION WITH GLEAM PROMO -->
			</div>
			<div
				v-if="section.position == 'mini-bar'"
				:key="'section-' + section.id"
				:style="{ backgroundImage: 'url(' + section.background_url + ')' }"
				class="row pos-r section-block"
			>
				<div class="container section-mini-bar">
					<hr >
					<div>
						<h3 class="text-uppercase" v-html="section.body" />
						<template v-for="button in section.landing_page_buttons">
							<a
								v-if="button.type == 1"
								:key="'button-' + button.id"
								:href="button.url"
								target="_blank"
								:class="`btn-section-${section.id}-${button.id}`"
								class="btn btn-green"
							>
								{{ button.text }}
							</a>
							<a
								v-if="button.type == 2"
								:key="'button-' + button.id"
								:class="`btn-section-${section.id}-${button.id}`"
								class="btn btn-green"
								@click="scrollToDiv('#influencer-pc')"
							>
								{{ button.text }}
							</a>
							<button
								v-if="button.type == 3"
								:key="'button-' + button.id"
								:class="`btn-section-${section.id}-${button.id}`"
								class="btn btn-green"
								@click="openVideoModal(button.url)"
							>
								{{ button.text }}
							</button>
							<a
								v-if="button.type == 4"
								:key="'button-' + button.id"
								:class="`btn-section-${section.id}-${button.id}`"
								class="btn btn-green"
								@click.prevent="sendToConfigurator(button.url, true)"
							>
								{{ button.text }}
							</a>
							<a
								v-if="button.type == 5"
								:key="'button-' + button.id"
								:class="`btn-section-${section.id}-${button.id}`"
								class="btn btn-green"
								href="#"
								@click.prevent="scrollToDiv(button.url)"
							>
								{{ button.text }}
							</a>
						</template>
					</div>
				</div>
			</div>
		</template>
		<!-- /.home -->
		<!-- bld-by-experts -->
		<div
			v-if="templateData.landing_page_builds.length"
			id="influencer-pc"
			class="row pos-r bg-white"
		>
			<div class="col-xs-12 p-a-0">
				<div class="container-fluid">
					<div class="row m-b-lg">
						<div class="visible-lg visible-md visible-sm">
							<!-- tabs -->
							<ul
								v-if="shouldShowPricetabs"
								:class="templateData.tab_style"
								class="nav nav-tabs text-center bg-black m-b-md"
								role="tablist"
							>
								<li
									v-for="(build, index) in templateData.landing_page_builds"
									:key="'build-tab-' + index"
									:class="{ active: index == 0 }"
								>
									<a
										:href="'#' + build.bld_number"
										:style="
											templateData.tab_style == 'promo'
												? {
													backgroundColor: build.bg_color,
													color: build.text_color
												}
												: ''
										"
										aria-controls="bld-max"
										class="bld-max text-bold"
										data-toggle="tab"
										role="tab"
										aria-expanded="true"
										@click="selectedBuildId = build.bld_number"
									>
										<img
											v-if="build.tab_icon"
											:src="build.tab_icon"
											class="tab-icon"
										>
										<span class="build-title">{{ build.title }}</span>
									</a>
								</li>
							</ul>
							<!-- /.tabs -->
							<!-- expert-content -->
							<div class="tab-content">
								<!-- ninjas -->
								<div
									v-for="(build, index) in templateData.landing_page_builds"
									v-show="selectedBuildId == build.bld_number"
									id="bld-max"
									:key="'build-detail-' + index"
									:class="{ active: selectedBuildId == build.bld_number }"
									role="tab-panel"
									class="tab-pane"
								>
									<div class="container section-global">
										<div class="intro-image">
											<img :src="build.image_url" class="img-response-w" >
										</div>
										<div class="text-wrapper-mid landing-page-heading">
											<div class="influencer-build">
												<div class="content-title-holder">
													<h2 class="text-upper m-a-0">{{ build.label }}</h2>
													<p class="text-green">
														${{ build.price | priceFormat }}
													</p>
												</div>
												<template v-if="+templateData.show_games">
													<div
														v-for="game in build.performance"
														:key="
															'build-games-' + build.bld_number + '-' + game.id
														"
														class="game-render-fps"
													>
														<div class="game-img pull-left">
															<img
																:src="game.images"
																:alt="game.name"
																class="img-response-w"
															>
														</div>
														<div class="game-desc pull-left">
															<p class="game-title">{{ game.name }}</p>
															<p class="game-fps">{{ game.game_value }}fps</p>
														</div>
													</div>
												</template>
											</div>
											<div class="row influencer-pc-specs m-t-md">
												<div class="col-xs-12 col-sm-6">
													<ol class="list-none">
														<li
															v-for="(special, key) in build.products.specials"
															:key="'special-' + build.bld_number + '-' + key"
															class="text-upper text-bold special-product"
														>
															{{ special.name }}
														</li>
														<li class="text-upper text-bold">
															{{ build.products.cases.name }}
															<span class="text-sm text-normal">CASE</span>
														</li>
														<li class="text-upper text-bold">
															{{ build.products.motherboards.name }}
															<span class="text-sm text-normal">MOBO</span>
														</li>
														<li class="text-upper text-bold">
															{{ build.products.cpus.name }}
															<span class="text-sm text-normal">CPU</span>
														</li>
														<li class="text-upper text-bold">
															{{ build.products.coolers.name }}
															<span class="text-sm text-normal">
																CPU COOLER
															</span>
														</li>
														<li class="text-upper text-bold">
															{{ build.products.gpus.name }}
															<span class="text-sm text-normal">GPU</span>
														</li>
														<li class="text-upper text-bold">
															{{ build.products.ram.name }}
															<span
																v-html="computeRamCapacity(
																	build.products.ram.capacity,
																	build.products.ram.slots,
																	build.products.ram.quantity
																)"
															/>
															<span class="text-sm text-normal">RAM</span>
														</li>
													</ol>
												</div>

												<div class="col-xs-12 col-sm-6">
													<ol class="list-none">
														<li
															v-for="(disk, key) in build.products.ssd"
															:key="'ssd-' + build.bld_number + '-' + key"
															class="text-upper text-bold"
														>
															{{ disk.name }}
															{{ disk.capacity }}
															<template v-if="disk.quantity > 1">
																({{ disk.quantity }})
															</template>
															<span class="text-sm text-normal">SSD</span>
														</li>
														<li
															v-for="(disk, key) in build.products.hdd"
															:key="'hdd-' + build.bld_number + '-' + key"
															class="text-upper text-bold"
														>
															{{ disk.name }}
															{{ disk.capacity }}
															<template v-if="disk.quantity > 1">
																({{ disk.quantity }})
															</template>
															<span class="text-sm text-normal">HDD</span>
														</li>
														<li class="text-upper text-bold">
															{{ build.products.psus.name }}
															<span class="text-sm text-normal">PSU</span>
														</li>
														<li
															v-for="(fan, key) in build.products.fans"
															:key="'fans-' + build.bld_number + '-' + key"
															class="text-upper text-bold"
														>
															{{ fan.name }}
															<template v-if="fan.quantity > 1">
																({{ fan.quantity }})
															</template>
															<span class="text-sm text-normal">FAN</span>
														</li>
														<li
															v-for="(extra, key) in build.products.extras"
															:key="'extras-' + build.bld_number + '-' + key"
															class="text-upper text-bold"
														>
															{{ extra.name }}
															<span class="text-sm text-normal">EXTRA</span>
														</li>
														<li
															v-for="(peripheral, key) in build.products
																.peripherals"
															:key="
																'peripherals-' + build.bld_number + '-' + key
															"
															class="text-upper text-bold"
														>
															{{ peripheral.name }}
															<span class="text-sm text-normal">
																PERIPHERAL
															</span>
														</li>
														<li
															v-for="(monitor, key) in build.products.monitors"
															:key="'monitors-' + build.bld_number + '-' + key"
															class="text-upper text-bold"
														>
															{{ monitor.name }}
															<template v-if="monitor.quantity > 1">
																({{ monitor.quantity }})
															</template>
															<span class="text-sm text-normal">MONITOR</span>
														</li>
													</ol>
												</div>
											</div>
											<template
												v-if="
													influencerName != 'dads-and-grads' &&
														Number(build.show_action_buttons)
												"
											>
												<div class="btn-brothers">
													<a
														href="#"
														class="btn btn-green m-y-md"
														@click.prevent="
															sendToConfigurator(build.bld_number, true)
														"
													>
														GET THIS BLD
													</a>
													<a
														href="#"
														class="btn btn-green btn-outline m-y-md"
														@click.prevent="
															sendToConfigurator(build.bld_number)
														"
													>
														CUSTOMIZE BUILD
													</a>
												</div>
											</template>
											<template v-else>
												<a
													href="#"
													class="btn btn-green m-y-md"
													:class="{ 'btn-disabled': processingCheckout }"
													@click.prevent="
														!processingCheckout &&
															sendToCheckout(build.spec_builds_id)
													"
												>
													GET THIS BLD
												</a>
											</template>
										</div>
									</div>
								</div>
								<!-- ninjas -->
							</div>
						</div>
						<div class="visible-xs pos-r front">
							<ul
								v-if="shouldShowPricetabs"
								id="price-tabs"
								:class="templateData.tab_style"
								class="nav nav-tabs text-center bg-black m-b-md front"
								role="tablist"
							>
								<li
									v-for="(build, index) in templateData.landing_page_builds"
									:key="'build-mobile-' + index"
									:class="{ active: selectedBuildId == build.bld_number }"
									:id="{ ninjaOp: index == 0 }"
								>
									<a
										:class="{ bldMax: index == 0, bldMedium: index != 0 }"
										:style="
											templateData.tab_style == 'promo'
												? {
													backgroundColor: build.bg_color,
													color: build.text_color
												}
												: ''
										"
										href="#"
										class="text-bold"
										aria-controls="bld-max-mobile"
										data-toggle="tab"
										role="tab"
										aria-expanded="true"
										@click="selectedBuildId = build.bld_number"
									>
										<img
											v-if="build.tab_icon"
											:src="build.tab_icon"
											class="tab-icon"
										>
										<span class="build-title">{{ build.title }}</span>
									</a>
								</li>
							</ul>
							<div class="tab-content">
								<!-- ninjas -->
								<div
									v-for="(build, bIdx) in templateData.landing_page_builds"
									v-show="selectedBuildId == build.bld_number"
									:key="'build-detail-mobile-' + bIdx"
									:id="build.bld_number"
									role="tab-panel"
									class="tab-pane active expert-content-holder"
								>
									<div class="container p-a-0">
										<div class="influencer-build">
											<div class="content-title-holder">
												<h2 class="text-upper m-a-0">{{ build.label }}</h2>
												<p class="text-green">
													${{ build.price | priceFormat }}
												</p>
											</div>
											<template v-if="+templateData.show_games">
												<div
													v-for="game in build.performance"
													:key="
														'build-games-mobile-' +
															build.bld_number +
															'-' +
															game.id
													"
													class="game-render-fps"
												>
													<div class="game-img pull-left">
														<img :src="game.images" class="img-response-w" >
													</div>
													<div class="game-desc pull-left">
														<p class="game-title">{{ game.name }}</p>
														<p class="game-fps">{{ game.game_value }}fps</p>
													</div>
												</div>
											</template>
										</div>
										<div class="intro-image">
											<img :src="build.image_url" class="img-response-w" >
										</div>
										<div class="row influencer-pc-specs m-t-md">
											<div class="col-xs-12 col-sm-6">
												<ol class="list-none">
													<li
														v-for="(special, index) in build.products.specials"
														:key="'special-' + build.bld_number + '-' + index"
														class="text-upper text-bold special-product"
													>
														{{ special.name }}
													</li>
													<li class="text-upper text-bold">
														{{ build.products.cases.name }}
														<span class="text-sm text-normal">CASE</span>
													</li>
													<li class="text-upper text-bold">
														{{ build.products.motherboards.name }}
														<span class="text-sm text-normal">MOBO</span>
													</li>
													<li class="text-upper text-bold">
														{{ build.products.cpus.name }}
														<span class="text-sm text-normal">CPU</span>
													</li>
													<li class="text-upper text-bold">
														{{ build.products.coolers.name }}
														<span class="text-sm text-normal">CPU COOLER</span>
													</li>
													<li class="text-upper text-bold">
														{{ build.products.gpus.name }}
														<span class="text-sm text-normal">GPU</span>
													</li>
													<li class="text-upper text-bold">
														{{ build.products.ram.name }}
														{{
															computeRamCapacity(
																build.products.ram.capacity,
																build.products.ram.slots,
																build.products.ram.quantity
															)
														}}
														<span class="text-sm text-normal">RAM</span>
													</li>
												</ol>
											</div>

											<div class="col-xs-12 col-sm-6">
												<ol class="list-none">
													<li
														v-for="(disk, index) in build.products.ssd"
														:key="
															'ssd-mobile-' + build.bld_number + '-' + index
														"
														class="text-upper text-bold"
													>
														{{ disk.name }}
														{{ disk.capacity }}
														<template v-if="disk.quantity > 1">
															({{ disk.quantity }})
														</template>
														<span class="text-sm text-normal">SSD</span>
													</li>
													<li
														v-for="(disk, index) in build.products.hdd"
														:key="
															'hdd-mobile-' + build.bld_number + '-' + index
														"
														class="text-upper text-bold"
													>
														{{ disk.name }}
														<template v-if="disk.quantity > 1">
															({{ disk.quantity }})
														</template>
														<span class="text-sm text-normal">HDD</span>
													</li>
													<li class="text-upper text-bold">
														{{ build.products.psus.name }}
														<span class="text-sm text-normal">PSU</span>
													</li>
													<li
														v-for="(fan, index) in build.products.fans"
														:key="
															'fans-mobile-' + build.bld_number + '-' + index
														"
														class="text-upper text-bold"
													>
														{{ fan.name }}
														<template v-if="fan.quantity > 1">
															({{ fan.quantity }})
														</template>
														<span class="text-sm text-normal">FAN</span>
													</li>
													<li
														v-for="(extra, index) in build.products.extras"
														:key="
															'extras-mobile-' + build.bld_number + '-' + index
														"
														class="text-upper text-bold"
													>
														{{ extra.name }}
														<span class="text-sm text-normal">EXTRA</span>
													</li>
													<li
														v-for="(peripheral, index) in build.products
															.peripherals"
														:key="
															'peripherals-mobile-' +
																build.bld_number +
																'-' +
																index
														"
														class="text-upper text-bold"
													>
														{{ peripheral.name }}
														<span class="text-sm text-normal">PERIPHERAL</span>
													</li>
													<li
														v-for="(monitor, index) in build.products.monitors"
														:key="
															'monitors-mobile-' +
																build.bld_number +
																'-' +
																index
														"
														class="text-upper text-bold"
													>
														{{ monitor.name }}
														<template v-if="monitor.quantity > 1">
															({{ monitor.quantity }})
														</template>
														<span class="text-sm text-normal">MONITOR</span>
													</li>
												</ol>
											</div>
										</div>
										<template
											v-if="
												influencerName != 'dads-and-grads' &&
													Number(build.show_action_buttons)
											"
										>
											<a
												href="#"
												class="btn btn-green m-y-md"
												@click.prevent="
													sendToConfigurator(build.bld_number, true)
												"
											>
												GET THIS BLD
											</a>
											<a
												href="#"
												class="btn btn-green btn-outline match m-y-md"
												@click.prevent="sendToConfigurator(build.bld_number)"
											>
												CUSTOMIZE BUILD
											</a>
										</template>
										<template v-else>
											<a
												href="#"
												class="btn btn-green m-y-md"
												:class="{ 'btn-disabled': processingCheckout }"
												@click.prevent="sendToCheckout(build.spec_builds_id)"
											>
												GET THIS BLD
											</a>
										</template>
									</div>
								</div>
								<!-- ninjas -->
							</div>
						</div>
						<!-- /.expert-content -->
					</div>
				</div>
			</div>
		</div>
		<!-- /.bld-by-experts -->
		<!-- bld-by-experts -->
		<div
			v-if="templateData.gleam_embed"
			id="promo-section"
			class="row pos-r bg-white pos-r front p-t-lg gleam-overlay"
		>
			<div class="col-xs-12 p-a-0">
				<div class="container-fluid">
					<div class="row m-b-lg">
						<div
							class="gleam-iframe text-center"
							v-html="templateData.gleam_embed"
						/>
					</div>
				</div>
			</div>
		</div>
		<!-- /.bld-by-experts -->
		<!-- service-package -->
		<div
			v-if="+templateData.show_services"
			id="home-service"
			class="service-package row"
		>
			<div>
				<div class="bld-features col-xs-12 p-a-0 m-y">
					<div class="service-details col-xs-12 col-md-3 text-center m-y">
						<div class="img-container">
							<i class="build-ico" />
						</div>
						<div class="content">
							<div class="text-white text-upper">
								<h3 class="text-bold">TAILORED FOR<br >GAMES</h3>
							</div>
							<div class="text text-white">
								<p class="text-bold">
									We’ve done the research and our algorithm takes care of the
									rest.
								</p>
							</div>
						</div>
						<router-link to="/what-is-bld" class="link-btn link-white">
							LEARN MORE
							<i class="fa fa-chevron-right" aria-hidden="true" />
						</router-link>
					</div>
					<div class="service-details col-xs-12 col-md-3 text-center m-y">
						<div class="img-container">
							<i class="glass"/>
						</div>
						<div class="content">
							<div class="text-white text-upper">
								<h3 class="text-bold">TRANSPARENT<br >PRICING</h3>
							</div>
							<div class="text text-white">
								<p class="text-bold">
									Customize your build with our curated parts with straight
									forward pricing and a flat $99 assembly fee.
								</p>
							</div>
						</div>
						<router-link to="/what-is-bld" class="link-btn link-white">
							LEARN MORE
							<i class="fa fa-chevron-right" aria-hidden="true" />
						</router-link>
					</div>
					<div class="service-details col-xs-12 col-md-3 text-center m-y">
						<div class="img-container">
							<i class="img-2year-ico"/>
						</div>
						<div class="content">
							<div class="text-white text-upper">
								<h3 class="text-bold">All-in-One<br >Warranty</h3>
							</div>
							<div class="text text-white">
								<p class="text-bold">
									All components under one warranty plan – NZXT will manage any
									problems for you.
								</p>
							</div>
						</div>
						<router-link to="/what-is-bld" class="link-btn link-white">
							LEARN MORE
							<i class="fa fa-chevron-right" aria-hidden="true" />
						</router-link>
					</div>
					<div class="service-details col-xs-12 col-md-3 text-center m-y">
						<div class="img-container">
							<i class="shipping-ico"/>
						</div>
						<div class="content">
							<div class="text-white text-upper">
								<h3 class="text-bold">48-Hour<br >Turnaround</h3>
							</div>
							<div class="text text-white">
								<p class="text-bold">
									Get in the game quickly.
								</p>
							</div>
						</div>
						<router-link to="/what-is-bld" class="link-btn link-white">
							LEARN MORE
							<i class="fa fa-chevron-right" aria-hidden="true" />
						</router-link>
					</div>
				</div>
			</div>
		</div>
		<template v-for="section in templateData.landing_page_sections">
			<div
				v-if="section.position == 'bottom'"
				id="hero"
				:class="{ 'gleam-promo': section.gleam_embed }"
				:key="'section-' + section.id"
				:style="{ backgroundImage: 'url(' + section.background_url + ')' }"
				class="row section-global pos-r section-block"
			>
				<div v-if="!section.gleam_embed" class="static-pages">
					<div class="static-pages-title">
						<div class="container">
							<div class="content-holder">
								<div
									class="intro-image"
									:style="{ order: getContentOrder(section, 'intro') }"
								>
									<img :src="section.logo_url" class="img-response-w" >
								</div>
								<div
									class="text-wrapper-mid landing-page-heading"
									:style="{ order: getContentOrder(section, 'heading') }"
								>
									<img
										v-if="section.mini_logo_url"
										:src="section.mini_logo_url"
										class="p-b"
										:style="{ order: getContentOrder(section, 'mini_logo') }"
									>
									<h1
										class="text-white text-upper"
										v-html="section.title"
										:style="{ order: getContentOrder(section, 'title') }"
									/>
									<h3
										class="text-white m-t-lg ql-editor"
										v-html="section.body"
										:style="{ order: getContentOrder(section, 'body') }"
									/>
									<div v-html="section.klaviyo_embed" style="order: 2;" />
									<div class="btn-brothers" style="order: 2;">
										<template v-for="button in section.landing_page_buttons">
											<a
												v-if="button.type == 1"
												:key="'button-' + button.id"
												:href="button.url"
												target="_blank"
												:class="`btn-section-${section.id}-${button.id}`"
												class="btn btn-green m-y-md"
											>
												{{ button.text }}
											</a>
											<a
												v-if="button.type == 2"
												:key="'button-' + button.id"
												:class="`btn-section-${section.id}-${button.id}`"
												class="btn btn-green m-y-md"
												@click="scrollToDiv('#influencer-pc')"
											>
												{{ button.text }}
											</a>
											<button
												v-if="button.type == 3"
												:key="'button-' + button.id"
												:class="`btn-section-${section.id}-${button.id}`"
												class="btn btn-green m-y-md"
												@click="openVideoModal(button.url)"
											>
												{{ button.text }}
											</button>
											<a
												v-if="button.type == 4"
												:key="'button-' + button.id"
												:class="`btn-section-${section.id}-${button.id}`"
												class="btn btn-green m-y-md"
												@click.prevent="sendToConfigurator(button.url, true)"
											>
												{{ button.text }}
											</a>
											<a
												v-if="button.type == 5"
												:key="'button-' + button.id"
												:class="`btn-section-${section.id}-${button.id}`"
												class="btn btn-green m-y-md"
												href="#"
												@click.prevent="scrollToDiv(button.url)"
											>
												{{ button.text }}
											</a>
										</template>
									</div>
									<!-- social -->
									<div
										v-if="
											section.has_social_links == 1 &&
												!(templateData.letsbld_url == '100thieves')
										"
										class="social-follow"
									>
										<h3 class="text-white">
											Follow {{ templateData.influencer_name }}:
										</h3>
										<a
											v-if="templateData.twitch"
											:href="templateData.twitch"
											target="_blank"
										>
											<img
												src="/images/brand-logos/twitch.svg"
												alt="TwitchTV"
												width="79"
											>
										</a>
										<a
											v-if="templateData.youtube"
											:href="templateData.youtube"
											target="_blank"
										>
											<img
												src="/images/brand-logos/youtube.svg"
												alt="YouTube"
												width="79"
											>
										</a>
										<a
											v-if="templateData.twitter"
											:href="templateData.twitter"
											target="_blank"
										>
											<img
												src="/images/logos/twitter.svg"
												alt="Twitter"
												width="79"
											>
										</a>
									</div>
									<div
										v-if="
											section.has_social_links == 1 &&
												templateData.letsbld_url == '100thieves'
										"
										class="social-follow"
									>
										<h3 class="text-white">
											Follow {{ templateData.letsbld_url }}:
										</h3>
										<a href="https://twitter.com/100Thieves" target="_blank">
											<img
												src="/images/logos/twitter.svg"
												alt="Twitter"
												width="79"
											>
										</a>
										<a href="https://www.twitch.tv/100thieves" target="_blank">
											<img
												src="/images/brand-logos/twitch.svg"
												alt="TwitchTV"
												width="79"
											>
										</a>
										<a
											href="https://www.instagram.com/100thievesgaming"
											target="_blank"
										>
											<img
												src="/images/brand-logos/instagram.svg"
												alt="Instagram"
												width="79"
											>
										</a>
									</div>
									<!-- /.social -->
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- SECTION WITH GLEAM PROMO -->
				<section v-else class="static-pages gleam-section">
					<div class="static-pages-title container">
						<div class="row">
							<div class="col-md-6">
								<div class="gleam-section-text">
									<h2 class="gleam-section-heading text-uppercase">
										{{ section.title | stripTags }}
									</h2>
									<div class="ql-editor" v-html="section.body" />
								</div>
							</div>
							<div class="col-md-6">
								<div
									class="gleam-section-insert"
									v-html="section.gleam_embed"
								/>
							</div>
						</div>
					</div>
				</section>
				<!-- /.SECTION WITH GLEAM PROMO -->
			</div>
		</template>
		<!-- /.service-package -->

		<template>
			<!-- Amd table comparsion -->
			<table-comparison
				v-if="
					templateData.letsbld_url == 'amd' && templateData.landing_page_builds
				"
			/>

			<!-- Amd terms and conditions -->
			<terms-Conditions
				v-if="
					templateData.letsbld_url == 'amd' && templateData.landing_page_builds
				"
			/>
		</template>

		<!-- bld-intro-text -->
		<div id="what-is-bld" class="row pos-r bg-black">
			<template v-for="section in templateData.landing_page_sections">
				<a
					v-if="['mini-left', 'mini-right'].includes(section.position)"
					:key="'section-' + section.id"
					:href="section.landing_page_buttons[0].url"
					:style="{ backgroundImage: 'url(' + section.background_url + ')' }"
					class="home-card bg-nzxt-section col-xs-12 col-md-6 p-a-0 pos-r section-block"
					target="_blank"
				>
					<div
						class="section-content-holder p-y-md p-x m-auto text-white front"
					>
						<div class="content-title-holder">
							<h2 class="text-upper">{{ section.title | stripTags }}</h2>
							<template v-for="button in section.landing_page_buttons">
								<a
									v-if="button.type == 1"
									:key="'btn-' + button.id"
									:href="button.url"
									class="link-btn link-white"
									target="_blank"
								>
									{{ button.text | upperCase }}
									<i class="fa fa-chevron-right" />
								</a>
							</template>
						</div>
						<img :src="section.logo_url" class="img-response-w" >
						<div class="clearfix" />
					</div>
				</a>
			</template>
		</div>
		<!-- /.bld-intro-text -->
		<div
			v-if="showVideoModal"
			id="video-modal"
			class="modal fade bs-example-modal-lg"
			tabindex="-1"
			role="dialog"
			aria-labelledby="myLargeModalLabel"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<iframe
						:src="youtubeVideoLink"
						width="100%"
						height="500"
						frameborder="0"
						allow="autoplay; encrypted-media"
						allowfullscreen
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { isMobile } from "@u/helpers";
import { computeRamCapacity } from "@u/store-helpers";
import { landingPagesMixin } from "@u/mixins";
import IntelPromoHero from "../landing-sections/intel-promo-hero";
import TableComparison from "../landing-sections/table-comparison";
import TermsConditions from "../landing-sections/terms-conditions";
import AmdPromoHero from "../landing-sections/amd-promo-hero";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

export default {
	name: "LandingPageTemplate",
	components: {
		IntelPromoHero,
		TableComparison,
		TermsConditions,
		AmdPromoHero
	},
	filters: {
		priceFormat(value) {
			return window.accounting.format(value, 2);
		},
		upperCase: function(value) {
			if (!value) {
				return "";
			}

			return value.toString().toUpperCase();
		}
	},
	mixins: [landingPagesMixin],
	data() {
		return {
			fixPriceBar: "",
			influencerName: "",
			processingCheckout: false,
			selectedBuildId: 0,
			showVideoModal: true,
			slickConfig: {
				dots: false,
				arrows: false,
				infinite: true,
				autoplay: true,
				speed: 300,
				slidesToShow: 4,
				slidesToScroll: 1,
				autoplaySpeed: 4000,
				responsive: [
					{
						breakpoint: 1366,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
							infinite: true
						}
					},
					{
						breakpoint: 770,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
				]
			},
			templateData: {
				landing_page_builds: []
			},
			youtubeVideoLink: ""
		};
	},
	computed: {
		shouldShowPricetabs() {
			return !!this.templateData.landing_page_builds[0].title.trim();
		}
	},
	created() {
		this.influencerName =
			this.$route.params.influencer || this.$route.meta.influencer;
	},
	mounted() {
		this.getTemplateData();
		$("#video-modal").on("hidden.bs.modal", () => {
			this.youtubeVideoLink = "";
		});

		if (this.influencerName == "discord" && !Cookies.get("promos-discord")) {
			const offset = new Date().getTimezoneOffset() / 60;
			const expires = moment("2019-02-22 23:00:00")
				.subtract(offset, "hours")
				.toDate();
			Cookies.set("promos-discord", "1", { expires });
		}

		setTimeout(() => {
			const script = document.createElement("script");
			script.type = "text/javascript";
			script.async = true;
			script.src = "https://js.gleam.io/e.js";
			const insertBefore = document.getElementsByTagName("script")[0];
			insertBefore.parentNode.insertBefore(script, insertBefore);
		}, 1000);
	},
	methods: {
		computeRamCapacity,
		getContentOrder(section, where) {
			const orders = [
				{
					intro: 0,
					heading: 1,
					mini_logo: 1,
					title: 0,
					body: 0
				},
				{
					intro: 1,
					heading: 0,
					mini_logo: 0,
					title: 1,
					body: 1
				}
			];

			if (isMobile(true)) {
				return orders[section.reverse_order_mobile][where];
			} else {
				return orders[section.reverse_order_desktop][where];
			}
		},
		getTemplateData() {
			axios({
				url: `/public-landing-pages/${this.influencerName}`
			})
				.then(response => {
					this.templateData = response.data;
					this.selectedBuildId =
						this.templateData.landing_page_builds[0] &&
						this.templateData.landing_page_builds[0].bld_number;
					this.setButtonRules();
				})
				.catch(error => {})
				.then(() => {
					this.initializeSlickGallery();
				});
		},
		initializeSlickGallery() {
			$(".bld-features").slick(
				Object.assign(this.slickConfig, {
					dots: true
				})
			);
		},
		sendToCheckout(bldNumber) {
			this.processingCheckout = true;

			const deviceType = isMobile(true) ? "mobile" : "desktop";
			const data = new FormData();
			data.append("source_device", deviceType);
			data.append("heap_uuid", localStorage.getItem("heap-uuid"));

			axios({
				url: `/checkout-refurbished/${bldNumber}`,
				method: "POST",
				data,
				headers: {
					token: window.CONFIG.SESSION
				}
			})
				.then(response => {
					const clear = `${this.shopifyDomain}/cart/clear.json`;
					$(".checkout-response iframe").attr("src", clear);

					setTimeout(() => {
						return $.ajax({
							type: "POST",
							url: `${this.shopifyDomain}/cart/add.json`,
							data: {
								quantity: 1,
								id: response.data.variant
							},
							dataType: "jsonp",
							success: function() {
								return (window.location = `${this.shopifyDomain}/checkout`);
							}
						});
					}, 1500);
				})
				.catch(() => {
					this.processingCheckout = false;
				});
		},
		setButtonRules() {
			const style = document.createElement("style");
			style.type = "text/css";
			document.querySelector("head").appendChild(style);

			this.templateData.landing_page_sections.forEach(section => {
				section.landing_page_buttons.forEach(button => {
					style.sheet.insertRule(
						`.btn-section-${section.id}-${button.id} { background-color: ${button.bg_color[0]}; color: ${button.text_color[0]}; border-color: ${button.bg_color[0]}; }`
					);
					style.sheet.insertRule(
						`.btn-section-${section.id}-${button.id}:hover { background-color: ${button.bg_color[1]}; color: ${button.text_color[1]}; border-color: ${button.bg_color[0]}; }`
					);
				});
			});
		},
		scrollToDiv(divId) {
			$("html,body").animate(
				{
					scrollTop: $(divId).offset().top - 100
				},
				1000
			);
		},
		openVideoModal(videoLink) {
			this.youtubeVideoLink = videoLink;
			$("#video-modal").modal("toggle");
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

#hero.gleam-promo {
	background-color: #110019;
	background-position: top center;
	background-size: 100%;
	max-height: none;
	padding-top: 38%;
	padding-bottom: 80px;

	@media (max-width: 580px) {
		padding-top: 40%;
	}
	@media (min-width: 1995px) {
		background-size: cover;
	}

	.ql-editor .ql-size-large {
		font-size: 1em;
	}
}

div[class~="100thieves-container"] {
	#hero:nth-child(1) {
		.text-wrapper-mid.landing-page-heading {
			padding-top: 35px;

			@media screen and (min-width: 991px) and (max-width: 1200px) {
				.btn-brothers a {
					width: 60%;
				}
			}
		}
	}
}

.courage-giveaway-container {
	@media (max-width: 1200px) {
		#hero:nth-child(3) .static-pages .content-holder .intro-image {
			display: none !important;
		}

		#hero:nth-child(4) .static-pages .content-holder .intro-image {
			display: none !important;
		}

		#hero:nth-child(5) .static-pages .content-holder .intro-image {
			display: none !important;
		}

		#hero:nth-child(6) .static-pages .content-holder .intro-image {
			display: none !important;
		}

		#hero:nth-child(6)
			.static-pages
			.content-holder
			.text-wrapper-mid.landing-page-heading
			> img {
			display: none !important;
		}
	}
}

.nickmercs-container {
	@media (max-width: 1200px) {
		#hero:nth-child(3),
		#hero:nth-child(6) {
			.static-pages .content-holder {
				.intro-image {
					display: none !important;
				}
			}
		}

		#hero:nth-child(7)
			.static-pages
			.content-holder
			.text-wrapper-mid.landing-page-heading
			> img {
			display: none !important;
		}
	}
}

.microsoft-windows-gaming-container {
	@media (max-width: 1200px) {
		#hero:nth-child(3),
		#hero:nth-child(4) {
			.static-pages .content-holder .intro-image {
				display: none !important;
			}
		}
	}
}

.btn-brothers {
	width: 100%;

	a {
		margin-bottom: 70px;

		@media (max-width: 570px) {
			margin-bottom: 30px;
		}
	}
}

.gleam-section {
	&__container {
		padding-top: 65px;
		padding-bottom: 45px;

		@media (min-width: 991px) {
			display: flex;
			justify-content: space-between;
		}
	}

	&-text {
		color: $white;

		@media (min-width: 580px) and (max-width: 991px) {
			padding-left: 100px !important;
			padding-right: 100px !important;
		}
	}

	&-heading {
		font-size: 48px;
		line-height: 52px;
		margin-bottom: 20px;
		margin-top: 10px;

		@media (max-width: 767px) {
			font-size: 36px;
			line-height: 38px;
			margin-bottom: 0;
		}
	}

	&-sub {
		font-size: 20px;
		line-height: 28px;
		margin-bottom: 40px;

		@media (max-width: 1200px) {
			font-size: 16px;
			line-height: 24px;
			margin-bottom: 30px;
		}
	}

	&-links {
		list-style: none;
		padding-left: 0;

		@media (max-width: 767px) {
			margin-bottom: 25px;
		}

		li {
			a {
				font-size: 20px;
				line-height: 51px;

				@media (max-width: 767px) {
					font-size: 16px;
					line-height: 32px;
				}
			}
		}
	}

	&-gleam {
		padding-left: 30px;
		text-align: center;
		width: 100%;

		@media (max-width: 1200px) {
			padding: 0;
		}

		@media (min-width: 580px) and (max-width: 991px) {
			padding-left: 100px;
			padding-right: 100px;
		}

		img {
			width: 100%;
		}
	}
}

.section-block {
	background-position: bottom center;
	background-repeat: no-repeat;
	background-size: cover;

	.landing-page-heading {
		display: flex;
		align-items: flex-start;
		flex-direction: column;
		padding-top: 80px;

		@media screen and (max-width: 1200px) {
			padding-top: 20px;
		}
	}
}

.overview-overlay .fps-graphing {
	display: flex;
	justify-content: center;
	align-items: flex-start;
	flex-wrap: wrap;
}

.overview-overlay .fps-graphing .fps-graphing-item {
	width: calc(100% / 3);
	text-align: center;
	margin-bottom: 0;
}

.text-white.screen-resolution-text {
	margin: 0;
}

.overview-overlay .fps-graphing .fps-graphing-item .vsync {
	font-size: 14px;
	font-family: "Akkurat-Normal";
}

.btn.btn-green.btn-outline.match.m-y-md {
	margin-top: 0 !important;
	margin-bottom: 0 !important;
}

.btn.btn.btn-green.btn-disabled {
	opacity: 0.5;
	cursor: default;
}

#influencer-pc .expert-content-holder {
	margin-bottom: 0;
}

.special-product {
	color: #3adec0;
}

#influencer-pc ul.nav-tabs {
	span {
		vertical-align: middle;
		font-size: 24px;
	}

	li {
		@media (max-width: 767px) {
			font-size: 20px;
		}

		img {
			height: 49px;
			width: 49px;
		}
	}

	&.promo {
		border-top: none;

		li {
			a {
				padding: 6px 15px;
			}

			img {
				margin: 13px 13px 13px 0;
			}

			&.active {
				margin-top: -23px;

				a {
					padding: 18px 15px 17px 15px;
				}
			}
		}
	}
}

hr {
	border-top: 1px solid $orchid;
	margin: 0 auto 50px;
	width: 100%;

	@media (max-width: 767px) {
		margin: 0 auto 30px;
	}
}

.section-mini-bar {
	align-items: center;
	display: flex;
	flex-direction: column;
	margin: 0px auto 50px;

	div {
		align-items: center;
		display: flex;
		max-width: 880px;

		@media (max-width: 991px) {
			align-items: initial;
			flex-direction: column;
		}

		@media (min-width: 767px) and (max-width: 991px) {
			padding: 0 20px;

			a {
				width: 100%;
				margin: 20px auto 10px;
			}
		}

		h3 {
			color: $white;
			font-size: 20px;
			letter-spacing: 1.3px;
			line-height: 22px;
			margin: 0;

			p {
				margin: 0 !important;
			}

			@media (max-width: 767px) {
				margin-bottom: 30px;
			}
		}
	}

	@media (max-width: 767px) {
		margin: 10px auto 90px;
	}

	@media (min-width: 767px) and (max-width: 991px) {
		margin-top: 20px;
		padding-left: 100px;
		padding-right: 100px;
	}

	@media (min-width: 320px) and (max-width: 991px) {
		flex-direction: column;
		align-items: initial;
		margin: 10px auto 50px;
	}
}

#influencer-pc .nav-tabs li a {
	@media (max-width: 767px) {
		font-size: 20px;
	}
}

@media screen and (max-width: 570px) and (min-width: 320px) {
	.ql-editor {
		.ql-size-huge {
			font-size: 1.5em !important;
		}
		.ql-size-large {
			font-size: 1em !important;
		}
	}

	#influencer-pc ul.nav-tabs {
		&.promo {
			li {
				a {
					.build-title {
						display: none;
					}
				}

				img {
					margin: 10px auto;
				}
			}
		}
	}
}

.landing-page-heading {
	@media screen and (max-width: 1023px) {
		min-height: auto !important;
	}
}

.landing-page-heading {
	min-height: 550px;
	padding-top: 30px;

	@media screen and (max-width: 1200px) {
		min-height: 500px;
	}
}
</style>

<style lang="scss">
#hero.gleam-promo {
	.ql-editor .ql-size-large {
		font-size: 20px;
	}
}

.section-mini-bar {
	div h3 p {
		margin: 0 !important;
	}
}
</style>
